import { toggleSideBar } from '@greenkub-fronts/domain/ui';
import { useDispatch, useSelector } from 'react-redux';

import { useWindowDimensions } from '@greenkub-fronts/shared/utils';
import { AppDispatch, RootState } from '@greenkub-fronts/shared/interface';
import CustomerMenuContent from '../../../ui/web/commons/customer-menu-content/customer-menu-content';

export function CustomerMenuContentFeature() {
  const dispatch = useDispatch<AppDispatch>();

  const { windowWidth } = useWindowDimensions();
  const { currentTheme } = useSelector((state: RootState) => state.ui);

  const handleClickLink = () => {
    if (windowWidth < 767) {
      dispatch(toggleSideBar(false));
    }
  };

  return (
    <CustomerMenuContent
      handleClickLink={handleClickLink}
      currentTheme={currentTheme}
    />
  );
}

export default CustomerMenuContentFeature;
